import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  listSubHeader: {
    fontWeight: 700,
    color: '#242424'
  }
}))
